import qs from 'qs';
import axios from 'axios';
import errorResponseInterceptor from '../interceptors';

const baseURL = process.env.VUE_APP_API_HOST;

const client = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
});

// Interceptors here....
client.interceptors.response.use(
  (response) => response,
  errorResponseInterceptor,
);

export default {
  // notifications
  async getNewNotificationsCount() {
    const response = await client.get('notification/');
    return response;
  },

  async getNotifications(params) {
    const response = await client.patch(`notification/${qs.stringify(params, { addQueryPrefix: true })}`);
    return response;
  },

  async markAsReadNotification(id) {
    const response = await client.patch(`notification/update/${id}/`);
    return response;
  },

  async markAllAsReadNotification() {
    const response = await client.patch('notification/update/');
    return response;
  },
};
